"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MySingleValue = void 0;
var React = require("react");
var MySingleValue = function (props) {
    var children = props.children, className = props.className;
    var myClassName = className ? className + " MuiFormLabel-root" : "MuiFormLabel-root";
    return React.createElement("div", { className: myClassName }, children);
};
exports.MySingleValue = MySingleValue;
